// extracted by css-extract-rspack-plugin
export default {"slidePanel__content":"slidePanel__content-GMA1Tv","slidePanelContent":"slidePanel__content-GMA1Tv"};